module.exports = __webpack_public_path__ + "static/media/cevrron-up.69d43e60.svg";